export default __webpack_public_path__ + "static/main-nav-558a56662c054d0a87ecce1326b25e88.mp4";